import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import WIDGETS_KEYS from '../widgets.keys';
import WIDGETS_MUTATIONS from '../widgets.mutation';
import WIDGETS_QUERIES from '../widgets.queries';

export const useFetchWidgets = ({ page, pageSize, search, ordering, filters } = {}) =>
  useQuery({
    queryKey: WIDGETS_KEYS.WIDGETS_PAGINATED({ page, pageSize, search, ordering, filters }),
    queryFn: () => WIDGETS_QUERIES.FETCH_WIDGETS({ page, pageSize, search, ordering, filters }),
    staleTime: 1 * 60 * 1000,
  });

export const useFetchWidget = (uid, options = {}) =>
  useQuery({
    queryKey: WIDGETS_KEYS.WIDGET_DETAIL(uid),
    queryFn: () => WIDGETS_QUERIES.FETCH_WIDGET(uid),
    enabled: !!uid,
    staleTime: 1 * 60 * 1000,
    ...options,
  });

export const useFetchWidgetPublic = (uid, options = {}) =>
  useQuery({
    queryKey: WIDGETS_KEYS.WIDGET_PUBLIC(uid),
    queryFn: () => WIDGETS_QUERIES.FETCH_WIDGET_PUBLIC(uid),
    enabled: !!uid,
    staleTime: 1 * 60 * 1000,
    ...options,
  });

export const useCreateWidget = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: WIDGETS_MUTATIONS.CREATE_WIDGET,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: WIDGETS_KEYS.WIDGETS() });
    },
  });
};

export const useUpdateWidget = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: WIDGETS_MUTATIONS.UPDATE_WIDGET,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: WIDGETS_KEYS.WIDGET_DETAIL(variables.uid),
      });
      queryClient.invalidateQueries({ queryKey: WIDGETS_KEYS.WIDGETS() });
    },
  });
};

export const useDeleteWidget = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: WIDGETS_MUTATIONS.DELETE_WIDGET,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: WIDGETS_KEYS.WIDGETS() });
    },
  });
};
